import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/martina/Desktop/Bigbang/web/app/[locale]/albums/AlbumsClient.tsx");
